/* fd26 — "Complete your setup" behavior.
   Multi-item add-on add via /cart/add.js, then replicates Focal's cart-drawer event sequence.
   The base net is intentionally handled only by the main PDP Add to Cart button.
   Cart-400 safety: Liquid only renders toggles for AVAILABLE variants, and the net id is
   read live from the variant picker. Progressive enhancement: bundle tier is plain links,
   and any add failure surfaces an inline message instead of breaking the page. */
(function () {
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    var numeric = Number(number);

    if (Number.isNaN(numeric) || number == null) return '0';

    var fixed = (numeric / 100).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function plainText(html) {
    if (html.indexOf('<') === -1 && html.indexOf('&') === -1) return html;

    var div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || html.replace(/<[^>]*>/g, '');
  }

  function money(cents) {
    var settings = window.themeVariables && window.themeVariables.settings ? window.themeVariables.settings : {};
    var format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';
    var value;

    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return plainText(formatString.replace(placeholderRegex, value)).replace(/([$£€¥])\s+(?=\d)/g, '$1');
  }

  function salePrice(cents, saleActive, percent) {
    var price = Number(cents || 0);
    if (!saleActive) return price;

    return Math.round(price * (100 - percent) / 100);
  }

  function waitForCartDrawerReady(timeout) {
    if (!window.customElements || !window.customElements.whenDefined) {
      return Promise.resolve(false);
    }

    if (window.customElements.get('cart-drawer')) {
      return Promise.resolve(true);
    }

    return Promise.race([
      window.customElements.whenDefined('cart-drawer').then(function () {
        return true;
      }),
      new Promise(function (resolve) {
        window.setTimeout(function () {
          resolve(!!window.customElements.get('cart-drawer'));
        }, timeout || 1200);
      })
    ]);
  }

  function closeMiniCartFallback() {
    var drawer = document.getElementById('mini-cart');
    if (!drawer) return;

    drawer.removeAttribute('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lock-all');
  }

  function openMiniCartFallback(sectionHtml) {
    var drawer = document.getElementById('mini-cart');
    if (!drawer) return;

    if (sectionHtml) {
      var container = document.createElement('div');
      container.innerHTML = sectionHtml;
      var nextDrawer = container.querySelector('#mini-cart');

      if (nextDrawer) {
        drawer.innerHTML = nextDrawer.innerHTML;
      }
    }

    drawer.setAttribute('open', '');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lock-all');
  }

  function init(root) {
    if (root.dataset.fd26Init) return;
    root.dataset.fd26Init = '1';

    var netVid = root.dataset.netVariant || '';
    var netPrice = parseInt(root.dataset.netPrice, 10) || 0;
    var productFormId = root.dataset.productFormId || '';
    var saleActive = root.dataset.fd26SaleActive === '1';
    var salePercent = parseInt(root.dataset.fd26SalePercent, 10) || 15;
    var themeRoutes = window.themeVariables && window.themeVariables.routes ? window.themeVariables.routes : {};
    var themeSettings = window.themeVariables && window.themeVariables.settings ? window.themeVariables.settings : {};
    var cartAddUrl = root.dataset.cartAddUrl || themeRoutes.cartAddUrl || '/cart/add';
    var cartUrl = root.dataset.cartUrl || themeRoutes.cartUrl || '/cart';
    var cartType = root.dataset.cartType || themeSettings.cartType || 'drawer';
    var ctaText = root.dataset.ctaLabel || 'Add to cart';
    var addText = root.dataset.addLabel || 'Add';
    var addedText = root.dataset.addedLabel || 'Added';
    var emptySelectionError = root.dataset.emptySelectionError || 'Choose at least one add-on.';
    var genericError = root.dataset.genericError || 'Sorry, something went wrong adding to cart. Please try again.';
    var networkError = root.dataset.networkError || 'Network error. Please try again.';

    var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-fd26-toggle]'));
    var cta = root.querySelector('[data-fd26-cta]');
    var ctaLabel = root.querySelector('[data-fd26-cta-label]');
    var errEl = root.querySelector('[data-fd26-err]');

    function selected() {
      return toggles.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; });
    }

    function recompute() {
      var sel = selected(), sum = 0;
      sel.forEach(function (t) { sum += parseInt(t.dataset.price, 10) || 0; });
      if (ctaLabel) ctaLabel.textContent = sel.length ? ctaText + ' - ' + money(sum) : ctaText;
      if (cta) {
        if (sel.length) {
          cta.removeAttribute('disabled');
        } else {
          cta.setAttribute('disabled', 'disabled');
        }
      }
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        var on = t.getAttribute('aria-pressed') === 'true';
        t.setAttribute('aria-pressed', on ? 'false' : 'true');
        t.classList.toggle('is-on', !on);
        var lbl = t.querySelector('[data-fd26-addtext]');
        if (lbl) lbl.textContent = on ? addText : addedText;
        recompute();
      });
    });

    document.addEventListener('variant:changed', function (e) {
      if (!e || !e.detail || !e.detail.variant) return;

      var sourceFormId = e.target && e.target.getAttribute ? e.target.getAttribute('id') : '';
      if (productFormId && sourceFormId !== productFormId) return;

      netVid = String(e.detail.variant.id);
      if (e.detail.variant.price != null) {
        netPrice = salePrice(e.detail.variant.price, saleActive, salePercent);
        recompute();
      }
    });

    function announceCart(addJson) {
      var form = root.closest('product-form') || document.querySelector('product-form');
      if (form) {
        form.dispatchEvent(new CustomEvent('variant:added', {
          bubbles: true,
          detail: { variant: (addJson.items ? addJson.items[0] : addJson), responseJson: addJson }
        }));
      }
      fetch(cartUrl + '.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return waitForCartDrawerReady(1400).then(function (cartDrawerReady) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            cart.sections = addJson.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart: cart, openMiniCart: cartType === 'drawer' }
            }));

            if (cartType !== 'drawer') return;

            window.setTimeout(function () {
              var drawer = document.getElementById('mini-cart');
              if (!drawer || drawer.hasAttribute('open')) return;

              if (cartDrawerReady && typeof drawer.open !== 'undefined') {
                drawer.open = true;
              } else {
                openMiniCartFallback(addJson.sections ? addJson.sections['mini-cart'] : '');
              }
            }, cartDrawerReady ? 900 : 80);
          });
        });
    }

    function addItems(items) {
      if (!items.length || !items[0].id) return;
      if (errEl) errEl.classList.remove('is-show');
      if (cta) {
        cta.setAttribute('disabled', 'disabled');
        cta.setAttribute('aria-busy', 'true');
      }
      fetch(cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: 'mini-cart' })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (cta) {
            cta.removeAttribute('disabled');
            cta.removeAttribute('aria-busy');
          }
          if (res.ok) {
            announceCart(res.json);
          } else if (errEl) {
            errEl.textContent = (res.json && res.json.description) ? res.json.description : genericError;
            errEl.classList.add('is-show');
          }
        })
        .catch(function () {
          if (cta) {
            cta.removeAttribute('disabled');
            cta.removeAttribute('aria-busy');
          }
          if (errEl) { errEl.textContent = networkError; errEl.classList.add('is-show'); }
        });
    }

    if (cta) {
      cta.addEventListener('click', function () {
        var items = [];
        selected().forEach(function (t) { items.push({ id: parseInt(t.dataset.vid, 10), quantity: 1 }); });
        if (!items.length) {
          if (errEl) {
            errEl.textContent = emptySelectionError;
            errEl.classList.add('is-show');
          }
          return;
        }
        addItems(items);
      });
    }

    recompute();
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('#mini-cart [data-action="close"], #mini-cart .drawer__overlay')) return;
    if (window.customElements && window.customElements.get && window.customElements.get('cart-drawer')) return;

    closeMiniCartFallback();
  });

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-fd26-cs]')).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
